import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

// Memoize the Stripe promise at module scope so we only call loadStripe once
// across the app lifetime — required by Stripe's SDK.
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = STRIPE_PUBLISHABLE_KEY ? loadStripe(STRIPE_PUBLISHABLE_KEY) : null;

/**
 * Wrap children in a Stripe Elements provider. Uses `clientSecret` when
 * provided (SetupIntent flow); otherwise renders a bare Elements shell.
 */
export const StripeElementsProvider = ({ clientSecret, children }) => {
  if (!stripePromise) {
    return (
      <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">
        Stripe publishable key not configured. Set <code>REACT_APP_STRIPE_PUBLISHABLE_KEY</code> in the frontend .env file.
      </div>
    );
  }

  const options = clientSecret
    ? {
        clientSecret,
        appearance: {
          theme: "stripe",
          variables: {
            colorPrimary: "#1B3A6B",
            colorText: "#0f172a",
            colorBackground: "#ffffff",
            fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
            borderRadius: "8px",
          },
        },
      }
    : {};

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

export { stripePromise };
export default StripeElementsProvider;
